'use client'

export default function PrivacyPolicyPage() {
  return (
    <main style={{ padding: '0px 20px', textAlign: 'center' }}>
      <h1>Лицензионное соглашение</h1>
      <iframe
        src="/docs/license.pdf"
        width="100%"
        height="800px"
        style={{ border: 'none', marginTop: '30px' }}
        title="Лицензионное соглашение"
      />
    </main>
  );
}
